module.exports = __webpack_public_path__ + "img/money-check-dollar.4ee091ff.svg";